import createTypeDecorator from '../decorators/createTypeDecorator'
// import {
//   getStringLengthValidator,
// } from 'pw-validators'

export const BOOL = Symbol("schemer.types.BOOL")
export const STRING = Symbol("schemer.types.STRING")
export const STRING_LONG = Symbol("schemer.types.STRING_LONG")
export const NUMBER = Symbol("schemer.types.NUMBER")
export const INTEGER = Symbol("schemer.types.INTEGER")

// const simpleStringValidator = (value, field) => {
//   const minLength = field.input.minLength 
//   const maxLength = field.input.maxLength 
//   if (maxLength || minLength) {
//     return getStringLengthValidator(minLength, maxLength)(value)
//   }
//   return null
// }

export const bool = createTypeDecorator(BOOL, {
  formatDisplay: val => {
    return !val ? 'False' : 'True'
  },
  input: {
    // validate: 
  },
  table: {
    width: 60
  }
})

export const string = createTypeDecorator(STRING, {
  formatDisplay: v => v && `${v}`,
  input: {
    // validate: simpleStringValidator
  },
  table: {
    width: 200
  }
})

export const stringLong = createTypeDecorator(STRING_LONG, {
  formatDisplay: v => v && `${v}`,
  input: {
    // validate: simpleStringValidator
  },
  table: {
    multiline: true,
    width: 200
  }
})

export const number = createTypeDecorator(NUMBER, {
  formatDisplay: v => v, //+v.toLocaleString(),
  input: {
    // min: 0,
    // max: Infinity
    // validate: simpleNumberValidator
  },
  table: {
    width: 80
  }
})

export const integer = createTypeDecorator(INTEGER, {
  formatDisplay: v => v, //+v.toLocaleString(),
  input: {
    // min: 0,
    // max: Infinity
    // validate: simpleIntValidator
  },
  table: {
    width: 80
  }
})